<template>
	<div>
        Conditions

        <div :id="'builder' + id"></div>

        <div>
            <b-input v-model="conditions" style="display: inline-block; width: 80%"></b-input>

            <b-button style="display: inline-block;" variant="link" v-b-toggle="'collapse' + id">Colonnes disponibles</b-button>
            <b-collapse :id="'collapse' + id">
                <div v-for="(column, idx) in columns" :keys="idx">
                    {{column.id}} ( {{ column.label }} )
                </div>
            </b-collapse>

            <br /><br />

            <categories_splash :lang="languages[0]" :edit="true" :tabulator="false" @update="update_categories" :search="true"></categories_splash>
            
        </div>

        <b-button variant="success" @click="search()">Rechercher</b-button>

        <div v-if="nb_results == -1">
            Recherche en cours
        </div> 
        <div v-else-if="nb_results == 0">
            Aucun résultat
        </div>
        <div v-else-if="nb_results">
            {{ nb_results }} résultat{{ nb_results > 1 ? "s": "" }}
        </div>

		<edit_tabulator v-show="nb_results && nb_results > 0 && !minimal" ref="tabulator" :extern_file="false" @update="import_file"></edit_tabulator>
	</div>
</template>

<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";
    import $ from "jquery";

	var clone = require("clone");

	import uniqueId from "lodash.uniqueid";

	import edit_tabulator from "../components/edit_tabulator.vue";
    import categories_splash from "./categories_splash.vue";
	import database_service from "../services/database.js";

	export default {
		name: "splash_categories_selector",
		components: {
			edit_tabulator,
            categories_splash
		},
		props: {
            client: {
				default: () =>  null
			},
			minimal: {
				default: false
			}
		},
		watch: {
		},
		data() {
			return {
				id: uniqueId(),

                rules_sql: "",
                rules_editor: "",
                conditions: "",
                conditionss_categories: [],
                nb_results: null,

                data: [],
                columns: [],
                languages: ["fr_FR"],

                object: "categories",
                mapping: {
                    "id":{"name":"Id SMD","column":"Id SMD","identifiant":false},
                    //"id_splash":{"name":"Id Splash Sync","column":"Id Splash Sync","identifiant":false},
                    "id_cms":{"name":"Id CMS","column":"Id CMS","identifiant":false},
                    "nom":{"name":"Nom","column":"","languages":{}},
                    "parent": {"name": "Catégorie parente", "column": "Catégorie parente"},
                    "description":{"name":"Description","column":"","languages":{}},
                    "additional_description":{"name":"Description complémentaires","column":"","languages":{}},
                    "link_rewrite":{"name":"URL simplifiée","column":"","languages":{}},
                    "meta_title":{"name":"Meta - nom","column":"","languages":{}},
                    "meta_description":{"name":"Meta - description","column":"","languages":{}},
                    "meta_keywords":{"name":"Meta - mots clés","column":"","languages":{}},
                    "position": {"name": "Position", "column": "Position"},
                },
            }
		},
		methods: {
            save()
            {

            },
            load()
            {

            },
            get_data()
            {
                return this.$refs.tabulator.get_data();
            },
            import_file()
            {
                console.log("import_file")
                this.$emit("update", this.$refs.tabulator.get_data());
            },
            update_categories(index, column, categories)
            {
                console.log(categories)
                this.conditionss_categories = categories;
            },
            construct_response(data)
            {
                var response = [];

                for (var k = 0; k < data.length; k++)
                {
                    response.push({});
                    var keys = Object.keys(this.mapping);
                    for (var i = 0; i < keys.length; i++)
                    {
                        if (this.mapping[keys[i]].column)
                        {
                            response[k][this.mapping[keys[i]].column] = data[k][keys[i]];
                        }
                        if (this.mapping[keys[i]].languages)
                        {
                            var keys_languages = Object.keys(this.mapping[keys[i]].languages);
                            for (var j = 0; j < keys_languages.length; j++)
                            {
                                var mapping = this.mapping[keys[i]].languages[keys_languages[j]]
                                if (mapping.column)
                                {
                                    if (data[k][keys[i]])
                                    {
                                        if (typeof data[k][keys[i]] == "string")
                                            data[k][keys[i]] = JSON.parse(data[k][keys[i]])
                                        if (data[k][keys[i]][keys_languages[j]])
                                            response[k][mapping.column] = data[k][keys[i]][keys_languages[j]];
                                        else
                                            response[k][mapping.column] = "";
                                    }
                                }
                            }
                        }
                    }
                }

                return response;
            },
            async search()
            {
                this.nb_results = -1;

                var where = this.rules_sql;
                if (this.conditionss_categories.length > 0)
                {
                    var c = JSON.parse(this.conditionss_categories);
                    if  (where)
                        where += " and ";
                    where += "(" + c.map(id => `parent = '${id}'`).join(' OR ') + ")";
                }

                console.log(where)

                var data = await database_service.get("select", this.object, {
                    select: "*",
                    where: where,
                    end: this.conditions,
                });

                this.data = this.construct_response(data);

                this.$refs.tabulator.set_data(this.data);

                this.nb_results = this.data.length;
            },
            setBuilder()
            {
				var id = this.id;
                var mapping = this.mapping;
                var self = this;

                try {
					$("#builder" + id).queryBuilder("destroy");
					self.rules_sql = "";
				} catch (err) {}

                var columns = [];

                if (this.client.details.splash && this.client.details.splash.languages)
                    this.languages = this.client.details.splash.languages;

                var keys = Object.keys(mapping)
                for (var i = 0; i < keys.length; i++)
                {
                    if (mapping[keys[i]].languages)
                    {
                        for (var j = 0; j < this.languages.length; j++)
                        {
                            columns.push({
                                id: keys[i] + "->>'$." + this.languages[j] + "'",
                                label: mapping[keys[i]].name + " - " + this.languages[j] /*+ " (" + keys[i] + "->>'$." + this.languages[j] + "'" + ")"*/,
                                type: "string",
                            })
                        }
                    }
                    else
                    {
                        columns.push({
                            id: keys[i],
                            label: (mapping[keys[i]].column || keys[i]) /*+ " (" + "`" + keys[i] + "`" + ")"*/,
                            type: mapping[keys[i]].type || "string",
                        })
                    }
                }

                if (!columns)
                    return;

                this.columns = columns

                var config = {
					filters: columns,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};
            
                $("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							//console.log(self.rules_sql)
							//self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);							
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							//self.updatePage();
						} catch (err) {
							self.rules_sql = "";
							self.rules_editor = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
						} catch (err) {
							self.rules_sql = "";
							self.rules_editor = "";
						}
					}
				);
            }
		},
		mounted: async function () {

			var self = this;

            this.languages = ["fr_FR"]
            if (this.client.details.splash && this.client.details.splash.languages)
                this.languages = this.client.details.splash.languages;
            if (this.client.details.prestashop && this.client.details.prestashop.languages)
                this.languages = this.client.details.prestashop.languages;

            var keys = Object.keys(this.mapping)
            for (var i = 0; i < keys.length; i++)
            {
                if (this.mapping[keys[i]].languages)
                {
                    for (var j = 0; j < this.languages.length; j++)
                    {
                        this.mapping[keys[i]].languages[this.languages[j]] = {
                            "name": this.languages[j], 
                            "column": this.mapping[keys[i]].name + " - " + this.languages[j]

                        }
                    }
                }
            }

            this.setBuilder();
		},
	};
</script>
